// File: frontend/src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector) // Use LanguageDetector
  .use(initReactI18next)
  .init({
    // Define supported languages (locales)
    supportedLngs: ['en', 'tr'],
    // Default language to use
    lng: 'tr', // Set initial language to Turkish explicitly for testing/default
    fallbackLng: 'en', // Fallback if 'tr' isn't available or a key is missing

    // Debug logging floods the console on production builds and leaks the
    // full key list; keep it for local development only.
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    backend: {
      // Ticket 1b: the loadPath used to carry a `?v=${Date.now()}` cache-busting
      // parameter. The original reason was staleness: browsers (and nginx)
      // aggressively cached the static locale JSON, so newly deployed keys showed
      // up as "missingKey" until a hard refresh.
      //
      // The timestamp produced a brand new URL on every single page load, which
      // broke offline support: the service worker keys its cache by full URL, so
      // no request ever matched a previously cached entry and the file failed with
      // net::ERR_FAILED once the network was gone.
      //
      // Freshness is now handled at the two layers that are actually responsible
      // for it, so the query param is no longer needed here:
      //   1. nginx serves /locales/ with "Cache-Control: no-cache", so the browser
      //      revalidates on every load and gets a cheap 304 when nothing changed.
      //   2. the service worker uses stale-while-revalidate for /locales/ — the
      //      cached copy is served immediately (and offline), while a fresh copy
      //      is fetched in the background for the next load.
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    ns: ['common'],
    defaultNS: 'common',

    // LanguageDetector options (optional, but can help fine-tune detection)
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'navigator'],
      caches: ['localStorage'], // Cache detected language in localStorage
    },
  });

export default i18n;